import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { place } from '../Utils';

const validPostcodes = new Set(place.map((p) => p.postcode));

function postcodeStatus(raw) {
    const v = raw.trim();
    if (!/^\d{4}$/.test(v)) return null;
    const n = parseInt(v, 10);
    return validPostcodes.has(n);
}

const ZipCodeCheckInput = () => {
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const status = postcodeStatus(value);

    let className = 'form-control';
    if (status === true) className += ' is-valid';
    if (status === false) className += ' is-invalid';

    return (
        <div className="mb-3">
            <label htmlFor="zip-code-check" className="form-label pl-0 ps-0">
                {t('zipCodeCheck.label')}
            </label>
            <div className="d-flex align-items-center">
            <input
                id="zip-code-check"
                type="text"
                inputMode="numeric"
                className={className}
                placeholder={t('zipCodeCheck.placeholder')}
                autoComplete="postal-code"
                maxLength={4}
                value={value}
                style={{ width: '140px', marginRight: '10px' }}
                onChange={(e) => setValue(e.target.value)}
            />
            {status === true && (
                <div className="valid-feedback d-block" style={{ fontSize: '15px' }}>{t('zipCodeCheck.valid')}</div>
            )}
            {status === false && (
                <div className="invalid-feedback d-block" style={{ fontSize: '15px' }}>{t('zipCodeCheck.invalid')}</div>
            )}
            </div>
        </div>
    );
};

export default ZipCodeCheckInput;
